import React from 'react';
import { Box,IconButton  } from 'theme-ui';
import { FaUser } from 'react-icons/fa'; 

export const HeaderProfile = () => {
  const profileURL = 'https://digitalcollections.franciscantradition.org/user-profile'; 

  return (
    <IconButton
    aria-label='Search'
     >
      <a href={profileURL}>
        <FaUser size={24} color="#A0AEC0" /> 
      </a>
      </IconButton>
  );
};